var modules = {
  bbs: {
    inject: false,
    path: 'https://static.max-c.com/webapp/font/1.0.3/heybox-web-app-bbs.css',
  },
  common: {
    inject: false,
    path: 'https://static.max-c.com/webapp/font/1.0.3/heybox-web-app-common.css',
  },
};
export default {
  install(Vue) {
    Vue.component('HbIcon', {
      render(h) {
        return h('i', {
          attrs: {
            class: `${this.iconType.module} ${this.iconType.type}`,
          },
        });
      },
      props: {
        name: {
          type: String,
          default: '',
        },
      },
      computed: {
        iconType() {
          let [_module, ...type] = (
            Object.keys(this.$attrs)[0] ||
            this.name ||
            ''
          ).split('-');

          if (!modules[_module]) {
            throw new Error('[HbIcon]: 没有相应的图标模块');
          }
          importCss(_module);
          type = type.join('-');
          return {
            module: `heybox-web-app-${_module}`,
            type: `hbicon-${type}`,
          };
        },
      },
    });
  },
};

function importCss(type) {
  if (!modules[type] || modules[type].inject) {
    return;
  }
  console.log(type);
  modules[type].inject = true;
  let temp = document.createElement('link');
  temp.href = modules[type].path;
  temp.rel = 'stylesheet';
  document.head.appendChild(temp);
}
